import ofertas from "@/config/brands/webpack";

describe("webpack ofertas exports", () => {
  it("se exporta correctamente las ofertas", () => {
    expect(ofertas).toBeDefined();
    expect(ofertas).not.toBeNull();
  });
});
